import {
  checkboxSchema,
  checkboxUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import FieldsetLabel from '../../../../components/FormDescriptions/FieldsetLabel';
import { OtherExposureDescription } from '../../../../components/FormDescriptions/OtherExposureDescriptions';
import content from '../../../../locales/en/content.json';

const TITLE_TEXT = content['service-info--exposures-title'];
const FIELDSET_LABEL = content['service-info--exposures-label'];
const INPUT_LABELS = {
  airPollutants: content['service-info--exposures-option--air-pollutants'],
  asbestos: content['service-info--exposures-option--asbestos'],
  chemicals: content['service-info--exposures-option--chemicals'],
  campLejeune: content['service-info--exposures-option--camp-lejeune'],
  mustardGas: content['service-info--exposures-option--mustard-gas'],
  hazards: content['service-info--exposures-option--hazards'],
  radiation: content['service-info--exposures-option--radiation'],
  shad: content['service-info--exposures-option--shad'],
  warfareAgents: content['service-info--exposures-option--warfare-agents'],
  other: content['service-info--exposures-option--other'],
};

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT, OtherExposureDescription),
    'view:otherToxicExposures': {
      'ui:title': FieldsetLabel(FIELDSET_LABEL),
      exposureToAirPollutants: checkboxUI(INPUT_LABELS.airPollutants),
      exposureToAsbestos: checkboxUI(INPUT_LABELS.asbestos),
      exposureToChemicals: checkboxUI(INPUT_LABELS.chemicals),
      exposureToContaminatedWater: checkboxUI(INPUT_LABELS.campLejeune),
      exposureToMustardGas: checkboxUI(INPUT_LABELS.mustardGas),
      exposureToOccupationalHazards: checkboxUI(INPUT_LABELS.hazards),
      exposureToRadiation: checkboxUI(INPUT_LABELS.radiation),
      exposureToShad: checkboxUI(INPUT_LABELS.shad),
      exposureToWarfareAgents: checkboxUI(INPUT_LABELS.warfareAgents),
      exposureToOther: checkboxUI(INPUT_LABELS.other),
    },
  },
  schema: {
    type: 'object',
    properties: {
      'view:otherToxicExposures': {
        type: 'object',
        properties: {
          exposureToAirPollutants: checkboxSchema,
          exposureToAsbestos: checkboxSchema,
          exposureToChemicals: checkboxSchema,
          exposureToContaminatedWater: checkboxSchema,
          exposureToMustardGas: checkboxSchema,
          exposureToOccupationalHazards: checkboxSchema,
          exposureToRadiation: checkboxSchema,
          exposureToShad: checkboxSchema,
          exposureToWarfareAgents: checkboxSchema,
          exposureToOther: checkboxSchema,
        },
      },
    },
  },
};
